import rawArticles from './articles.json';

export type ArticleImage = {
  src: string;
  alt: string;
  caption?: string;
};

export type ArticleSection = {
  heading: string;
  paragraphs: string[];
  listTitle?: string;
  listItems?: string[];
  image?: ArticleImage;
};

export type ArticleFaq = {
  question: string;
  answer: string;
};

export type Article = {
  slug: string;
  title: string;
  description: string;
  seoTitle: string;
  seoDescription: string;
  category: string;
  publishedAt: string;
  updatedAt: string;
  readingTime: string;
  image: ArticleImage;
  keywords: string[];
  intro: string;
  quickAnswer: string;
  takeaways: string[];
  sections: ArticleSection[];
  faq: ArticleFaq[];
  relatedSlugs: string[];
};

export const articles = rawArticles as Article[];

const articleMap = new Map(articles.map((article) => [article.slug, article]));

export function getArticleBySlug(slug: string) {
  return articleMap.get(slug);
}

export function getRelatedArticles(article: Article) {
  return article.relatedSlugs
    .map((slug) => articleMap.get(slug))
    .filter((related): related is Article => Boolean(related));
}
